export default __webpack_public_path__ + "319aac02e629c637aef01a1f30e4a203.png";